import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export default function GraficoLinhas2({ dadosEvolucao, mediaFinal }) {
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
        labels: {
          usePointStyle: true,
          padding: 20,
          font: {
            size: 14,
            weight: '600'
          },
          color: '#333'
        }
      },
      title: {
        display: true,
        text: 'Evolução das Competências Gerais',
        font: {
          size: 18,
          weight: '700'
        },
        color: '#333',
        padding: {
          top: 10,
          bottom: 30
        }
      },
      tooltip: {
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        titleColor: '#333',
        bodyColor: '#666',
        borderColor: '#667eea',
        borderWidth: 2,
        cornerRadius: 12,
        displayColors: true,
        padding: 12
      }
    },
    layout: {
      padding: {
        top: 20,
        bottom: 20,
        left: 15,
        right: 15,
      },
    },
    scales: {
      x: {
        grid: {
          color: 'rgba(0, 0, 0, 0.05)',
          lineWidth: 1
        },
        ticks: {
          maxRotation: 45,
          minRotation: 0,
          color: '#666',
          font: {
            size: 12,
            weight: '500'
          }
        },
        // Centralizar pontos quando há apenas um período
        offset: dadosEvolucao.labels && dadosEvolucao.labels.length === 1,
      },
      y: {
        beginAtZero: true,
        max: 220,
        grid: {
          color: 'rgba(0, 0, 0, 0.05)',
          lineWidth: 1
        },
        ticks: {
          stepSize: 40,
          color: '#666',
          font: {
            size: 12,
            weight: '500'
          },
          callback: function(value) {
            return value === 220 ? '' : value;
          },
        },
      },
    },
  };

  // Se só há um período, mostrar como ponto único
  const isUnicoPeriodo = dadosEvolucao.labels && dadosEvolucao.labels.length === 1;
  
  if (isUnicoPeriodo) {
    options.elements = {
      point: {
        radius: 8,
        hoverRadius: 10,
      },
    };
  }

  const data = {
    labels: dadosEvolucao.labels || [],
    datasets: [
      {
        label: 'Competência 1',
        data: dadosEvolucao.competencia1 || [],
        borderColor: '#667eea',
        backgroundColor: 'rgba(102, 126, 234, 0.1)',
        borderWidth: 4,
        pointRadius: 6,
        pointHoverRadius: 8,
        pointBackgroundColor: '#667eea',
        pointBorderColor: '#fff',
        pointBorderWidth: 3,
        pointHoverBackgroundColor: '#667eea',
        pointHoverBorderColor: '#fff',
        tension: 0,
        fill: true,
      },
      {
        label: 'Competência 2',
        data: dadosEvolucao.competencia2 || [],
        borderColor: '#764ba2',
        backgroundColor: 'rgba(118, 75, 162, 0.1)',
        borderWidth: 4,
        pointRadius: 6,
        pointHoverRadius: 8,
        pointBackgroundColor: '#764ba2',
        pointBorderColor: '#fff',
        pointBorderWidth: 3,
        pointHoverBackgroundColor: '#764ba2',
        pointHoverBorderColor: '#fff',
        tension: 0,
        fill: true,
      },
      {
        label: 'Competência 3',
        data: dadosEvolucao.competencia3 || [],
        borderColor: 'rgb(255, 206, 86)',
        backgroundColor: 'rgba(255, 206, 86, 0.1)',
        borderWidth: 4,
        pointRadius: 6,
        pointHoverRadius: 8,
        pointBackgroundColor: 'rgb(255, 206, 86)',
        pointBorderColor: '#fff',
        pointBorderWidth: 3,
        pointHoverBackgroundColor: 'rgb(255, 206, 86)',
        pointHoverBorderColor: '#fff',
        tension: 0,
        fill: true,
      },
      {
        label: 'Competência 4',
        data: dadosEvolucao.competencia4 || [],
        borderColor: 'rgb(75, 192, 192)',
        backgroundColor: 'rgba(75, 192, 192, 0.1)',
        borderWidth: 4,
        pointRadius: 6,
        pointHoverRadius: 8,
        pointBackgroundColor: 'rgb(75, 192, 192)',
        pointBorderColor: '#fff',
        pointBorderWidth: 3,
        pointHoverBackgroundColor: 'rgb(75, 192, 192)',
        pointHoverBorderColor: '#fff',
        tension: 0,
        fill: true,
      },
      {
        label: 'Competência 5',
        data: dadosEvolucao.competencia5 || [],
        borderColor: 'rgb(153, 102, 255)',
        backgroundColor: 'rgba(153, 102, 255, 0.1)',
        borderWidth: 4,
        pointRadius: 6,
        pointHoverRadius: 8,
        pointBackgroundColor: 'rgb(153, 102, 255)',
        pointBorderColor: '#fff',
        pointBorderWidth: 3,
        pointHoverBackgroundColor: 'rgb(153, 102, 255)',
        pointHoverBorderColor: '#fff',
        tension: 0,
        fill: true,
      },
    ],
  };

  return (
    <div style={{ 
      maxWidth: '1000px', 
      margin: '0 auto', 
      padding: '0 20px' 
    }}>
      {dadosEvolucao.labels && dadosEvolucao.labels.length > 0 ? (
        <div style={{ 
          height: '400px', 
          width: '100%',
          marginBottom: '20px'
        }}>
          <Line options={options} data={data} />
        </div>
      ) : (
        <div className="text-center p-4">
          <p className="text-muted">Nenhum dado de evolução disponível</p>
        </div>
      )}
      
      {/* Médias finais */}
      <div className="mt-3" style={{
        maxWidth: '800px',
        margin: '20px auto 0'
      }}>
        <div className="row text-center">
          <div className="col">
            <div className="border rounded p-2" style={{ 
              backgroundColor: 'rgba(255, 99, 132, 0.1)',
              height: '65px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center'
            }}>
              <small className="text-muted" style={{ fontSize: '10px', lineHeight: '1.2' }}>Média<br/>Competência 1</small>
              <div style={{ color: '#333' }}><strong>{mediaFinal.competencia1 || 0}</strong></div>
            </div>
          </div>
          <div className="col">
            <div className="border rounded p-2" style={{ 
              backgroundColor: 'rgba(54, 162, 235, 0.1)',
              height: '65px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center'
            }}>
              <small className="text-muted" style={{ fontSize: '10px', lineHeight: '1.2' }}>Média<br/>Competência 2</small>
              <div style={{ color: '#333' }}><strong>{mediaFinal.competencia2 || 0}</strong></div>
            </div>
          </div>
          <div className="col">
            <div className="border rounded p-2" style={{ 
              backgroundColor: 'rgba(255, 206, 86, 0.1)',
              height: '65px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center'
            }}>
              <small className="text-muted" style={{ fontSize: '10px', lineHeight: '1.2' }}>Média<br/>Competência 3</small>
              <div style={{ color: '#333' }}><strong>{mediaFinal.competencia3 || 0}</strong></div>
            </div>
          </div>
          <div className="col">
            <div className="border rounded p-2" style={{ 
              backgroundColor: 'rgba(75, 192, 192, 0.1)',
              height: '65px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center'
            }}>
              <small className="text-muted" style={{ fontSize: '10px', lineHeight: '1.2' }}>Média<br/>Competência 4</small>
              <div style={{ color: '#333' }}><strong>{mediaFinal.competencia4 || 0}</strong></div>
            </div>
          </div>
          <div className="col">
            <div className="border rounded p-2" style={{ 
              backgroundColor: 'rgba(153, 102, 255, 0.1)',
              height: '65px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center'
            }}>
              <small className="text-muted" style={{ fontSize: '10px', lineHeight: '1.2' }}>Média<br/>Competência 5</small>
              <div style={{ color: '#333' }}><strong>{mediaFinal.competencia5 || 0}</strong></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}